import moment from 'moment';

Vue.component('powerhour-stats', {
    props: ['id'],

    data () {
        return {
            audio: null,

            newSale: false,

            loading: false,

            dashboardData: null,

            timeout: null,

            viewingData: false,

            dataLoading: false
        };
    },

    mounted () {
        if (this.id === undefined) {
            $('body').removeClass('sidebar-lg-show');

            this.pollData();
        } else if (this.id !== null) {
            this.apiRequest();
        }
    },

    methods: {
        showNewSale (name) {
            this.newSale = name;

            var audio = new Audio('/sounds/success.mp3');
            audio.play();

            audio.addEventListener('ended', () => {
                setTimeout(() => {
                    this.newSale = false;
                }, 5000);
            });
        },

        apiRequest () {
            axios.get('/api/dashboard/powerhour' + (this.id !== undefined && this.id !== null ? '?force=' + this.id : '')).then((response) => {
                this.dashboardData = response.data;
            });
        },

        pollData () {
            this.apiRequest();

            this.timeout = setTimeout(this.pollData, 15000);
        },

        viewData (type, id, admin) {
            this.viewingData = {
                type,
                admin
            };

            $('#view-data').modal('show');

            this.dataLoading = true;

            axios.get('/api/dashboard/view_data', {
                params: {
                    type,
                    id,
                    power_session: this.id
                }
            }).then((response) => {
                this.dataLoading = false;
                this.viewingData.data = response.data;
            });
        },
    },

    computed: {
        sortedAdmins () {
            let admins = this.dashboardData.admins.sort((b, a) => {
                return a.calls_connected - b.calls_connected;
            });

            let position = 1;
            for (let admin in admins) {
                admins[admin].position = position++;
            }

            return admins;
        }
    },

    filters: {
        formatDate (value) {
            return moment(value).format("DD/MM HH:mm");
        },

        date (value) {
            return moment(value).format("DD/MM/YYYY HH:mm");
        }
    },

    watch: {
        id () {
            this.apiRequest();
        }
    }
});

